<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
   data(){
     return{
     
     }
   },
}
</script>

<style>
  #app {
    font-family: PingFangSC-Medium;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  .container{
    padding: 13px 11px 26px;
  }
  .rc-anchor-normal{
    width: auto!important;
  }
  .rc-anchor-normal .rc-anchor-content{
    height: 43px!important;
    width: 130px!important;
  }
  /deep/.van-dialog{
    z-index: 9999;
  }
</style>
